// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
/*引入全局样式*/
import './common/main.less'
import './common/animate.min.css'
Vue.prototype.$http = axios;
Vue.prototype.basePath = '.';
/* Vue.prototype.msg = '';
Vue.prototype.msgShow = false;
Vue.prototype.msgTimer = null;
Vue.prototype.aaaa = 333;
Vue.prototype.msgShowFn = function (msg) {
	console.log(this.aaaa);
	
	if (this.msgTimer == null) {
		this.msg = msg;
		this.msgShow = true;
		this.msgTimer = setTimeout(() => {
			console.log(msg);
			
			this.msgShow = false;
			console.log(this.msgShow);
			this.msgTimer = null;
		}, 1200);
	}
}; */
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	template: '<App/>',
	components: { App }
});
/**配置全局变量 */



// WEBPACK FOOTER //
// ./src/main.js